<script setup lang="ts">
import { useSearchStore } from "@/stores/search";
import { VueAwesomePaginate } from "vue-awesome-paginate";
import { computed } from "vue";
import scrollToTop from "@/lib/dom/scrollToTop";
import { useScreens } from "vue-screen-utils";
import { DEFAULT_BREAKPOINT_DEFINITIONS } from "@/lib/util/breakpoint";

const store = useSearchStore();
const { saveSubmittedPagination } = store;

const { mapCurrent } = useScreens({
    lapAndUp: DEFAULT_BREAKPOINT_DEFINITIONS.lapAndUp,
});
const maxPages = mapCurrent({ lapAndUp: 5 }, 3);
const isMaxResultCountExceeded = computed(() => {
    return store.isMaxResultCountExceeded;
});

const onClickHandler = async (currentPage: number) => {
    await saveSubmittedPagination(currentPage);
    setTimeout(() => scrollToTop(), 0);
};
</script>
<template>
    <div
        v-if="!isMaxResultCountExceeded && store.getPageCount > 1"
        class="[ c-pagination ]"
    >
        <vue-awesome-paginate
            :total-items="store.getTotalResults"
            :items-per-page="store.configuration.itemsPerPage"
            :backButtonClass="
                store.page === 1 ? 'disabled back-button' : 'back-button'
            "
            :max-pages-shown="maxPages"
            :nextButtonClass="
                store.page === store.getPageCount
                    ? 'disabled next-button'
                    : 'next-button'
            "
            v-model="store.page"
            @click="onClickHandler"
        >
            <template #prev-button>
                <i class="[ c-icon ] [ icon-arrow--left ]"></i>
            </template>
            <template #next-button>
                <i class="[ c-icon ] [ icon-arrow--right ]"></i>
            </template>
        </vue-awesome-paginate>
    </div>
</template>
